import { combineReducers, Reducer } from "redux";
import { UserRolesState } from "@models/user-role";
import { UserRolesActionTypes } from "@actions/user-role";

// Type-safe initialState!
export const initialState: UserRolesState = {
  allIds: [],
  byId: {},
  loading: false,
  count: 0
};

const byId = (state = initialState.byId, action) => {
  switch (action.type) {
    case UserRolesActionTypes.FETCH_SUCCESS: {
      const { data } = action.payload;
      return {
        ...data.reduce((obj, userRole) => {
          obj[userRole.id] = {
            ...userRole,
            is_fetched: false,
            ...(state[userRole.id] || {}) //The data which fetch by id is more than data in Table
          };
          return obj;
        }, {})
      };
    }
    
    case UserRolesActionTypes.DELETE_SUCCESS:
      return Object.keys(state)
        .filter(id => id !== action.payload.id)
        .reduce((result, current) => {
          result[current] = state[current];
          return result;
        }, {});
    
    case UserRolesActionTypes.CREATE_SUCCESS: {
      const userRole = action.payload;
      return {
        ...state,
        [userRole.id]: userRole
      };
    }
    
    case UserRolesActionTypes.UPDATE_SUCCESS: {
      const userRole = action.payload;
      return {
        ...state,
        [userRole.id]: {
          ...state[userRole.id],
          ...userRole
        }
      };
    }
  
    case UserRolesActionTypes.FETCH_ITEM_REQUEST: {
      const userRole = action.payload;
      return {
        ...state,
        [userRole.id]: {
          ...state[userRole.id],
          is_fetched: false
        }
      };
    }
    
    case UserRolesActionTypes.FETCH_ITEM_SUCCESS: {
      const userRole = action.payload;
      return {
        ...state,
        [userRole.id]: {
          ...state[userRole.id],
          ...userRole,
          is_fetched: true
        }
      };
    }
    
    default:
      return state;
  }
};

const allIds = (state = initialState.allIds, action) => {
  switch (action.type) {
    case UserRolesActionTypes.FETCH_SUCCESS: {
      const { data } = action.payload;
      return data.map(item => item.id);
    }
    
    case UserRolesActionTypes.DELETE_SUCCESS:
      const deletedFormIndex = state.indexOf(action.payload.id);
      return [
        ...state.slice(0, deletedFormIndex),
        ...state.slice(deletedFormIndex + 1)
      ];
    
    case UserRolesActionTypes.CREATE_SUCCESS:
      return [action.payload.id, ...state];
    
    default:
      return state;
  }
};

const count = (state = initialState.count, action) => {
  switch (action.type) {
    case UserRolesActionTypes.FETCH_SUCCESS: {
      const { meta } = action.payload;
      return meta.total_count;
    }
    
    case UserRolesActionTypes.DELETE_SUCCESS:
      return state - 1;
    
    case UserRolesActionTypes.CREATE_SUCCESS:
      return state + 1;
    default:
      return state;
  }
};

const loading = (state = initialState.loading, action) => {
  switch (action.type) {
    case UserRolesActionTypes.FETCH_REQUEST: {
      return true;
    }
    
    case UserRolesActionTypes.FETCH_SUCCESS:
    case UserRolesActionTypes.FETCH_ERROR:
      return false;
    
    default:
      return state;
  }
};

const reducer: Reducer<UserRolesState> = combineReducers({
  byId,
  allIds,
  count,
  loading
});

export { reducer as userRoleReducer };

//Selectors
export const getUserRolesList = userRoles => userRoles.allIds.map(id => userRoles.byId[id]);

export const getUserRoleById = (userRoles, id) => userRoles.byId[id];
